import ProfilePopup from '../profile-popup/index'
import globals from '../../utils/globals'
import { Component } from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'

class UserMentions extends Component {
  constructor () {
    super()
    this.state = {
      doesUserExist: false
    }
  }
  componentDidMount () {
    getWithInMemoryCache('/member/doesUserExist', {
      memberId: this.props.id
    }).then(res => this.setState({ doesUserExist: res.result }))
  }

  render (props, state) {
    const { id, content, parentEl } = props
    return (
      <span>
        {
          state.doesUserExist ? (
            <a className={`${!state.doesUserExist ? 'anonymous-user' : ''}`} href={globals('application') !== 'control' ? `/members/mid-${id}` : `/member/profile?userid=${id}`}>
              {content}
              <ProfilePopup hoverControl={parentEl} memberId={id} />
            </a>
          ) : <span>{ content }</span>
        }
      </span>
    )
  }
}

export default UserMentions
